var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white black--text d-flex wrapper h100 vh100 pa-50 center"},[_c('div',{staticClass:"tos"},[_c('Privacy')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }